<template>
    <div class="side-bar">
        <div class="plug-menu themeStyle flex-cc" :class="isOpen ? 'open' : 'close'" @click="isOpen = !isOpen;"><span class="el-icon-plus"></span></div>

        <div 
        :class="['bar', 'themeStyle', 'plug-btn', 'plug-btn1', 
        {'open': isOpen}, {'close': !isOpen}]" @click="refreshWeb">
            <div class="icon-box theme f7 flex-cc">
                <i class="el-icon-refresh-right"></i>
            </div>
            <div class="f7 fs12">刷新</div>
        </div>

        <template v-if="showCompanyPicker">
            <el-popover
                v-if="!companyDisabled"
                placement="top"
                width="330"
                v-model="checkConPop"
                trigger="click">
                <div class="user-picker">
                    <div class="fs16 f7 m-b-16">选择公司</div>
                    <div class="list-wrap">
                        <div 
                        :class="[{'active': curCompany.id == item.id},'picker-item']" 
                        v-for="item in companyList" 
                        :key="item.id"
                        @click="companyChange(item)">{{item.name}}</div>
                    </div>
                </div>
                <div slot="reference" :class="['bar', 'themeStyle', 'plug-btn', 'plug-btn2', {'open': isOpen}, {'close': !isOpen}]">
                    <div class="icon-box theme f7 flex-cc">
                        <i class="el-icon-office-building"></i>
                    </div>
                    <div class="f7 fs12">{{curCompany.name}}</div>
                </div>
            </el-popover>
            <div v-else :class="['bar', 'themeStyle', 'plug-btn', 'plug-btn2', {'open': isOpen}, {'close': !isOpen}]">
                <div class="icon-box gray80 f7 flex-cc">
                    <i class="el-icon-office-building"></i>
                </div>
                <div class="f7 fs12 gray80">{{curCompany.name}}</div>
            </div>
        </template>

        <div :class="['bar', 'themeStyle', 'plug-btn', {'plug-btn3': showCompanyPicker}, {'plug-btn2': !showCompanyPicker}, {'open': isOpen}, {'close': !isOpen}]">
            <div class="icon-box theme f7 flex-cc">
                <i class="el-icon-date"></i>
            </div>
            <div class="f7 fs12">{{activeDate}}</div>
            <div class="date-picker">
                <el-date-picker
                    :clearable="false"
                    :editable="false"
                    v-model="activeDate"
                    @change="dateChange"
                    :picker-options="pickerOptions"
                    prefix-icon="a"
                    value-format="yyyy-MM"
                    type="month"
                    placeholder="选择月">
                </el-date-picker>
            </div>
        </div>
        <el-popover
            v-if="showUserPicker"
            placement="bottom"
            width="422"
            v-model="checkUserPop"
            trigger="click">
            <div class="user-picker">
                <div class="fs16 f7 m-b-16">选择员工</div>
                <div class="list-wrap">
                    <div 
                    :class="[{'active': activePickerKey == item.userId},'picker-item']" 
                    v-for="item in list" 
                    :key="item.userId"
                    @click="userChange(item)">{{item.userName}}</div>
                </div>
            </div>
            <div 
            slot="reference" 
            :class="['bar', 'themeStyle', 'plug-btn',
            {'plug-btn4': showCompanyPicker},
            {'plug-btn3': !showCompanyPicker},
            {'open': isOpen}, {'close': !isOpen}]"
            >
                <div class="icon-box theme f7 flex-cc">
                    <i class="el-icon-user"></i>
                </div>
                <div class="f7 fs12">{{curUserName}}</div>
            </div>
        </el-popover>
        
        <div :class="['bar', 'themeStyle', 'plug-btn', 'plug-btn4', {'open': isOpen}, {'close': !isOpen}]" @click="backTop">
            <div class="icon-box theme f7 flex-cc">
                <i class="el-icon-caret-top"></i>
            </div>
            <div class="f7 fs12">TOP</div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        list: {
            type: Array,
            default: () => {
                return [];
            }
        },
        listActive: {
            type: String,
            default: ''
        },
        showUserPicker: {
            type: Boolean,
            default: false
        },

        showCompanyPicker: {
            type: Boolean,
            default: false
        },

        companyDisabled: {
            type: Boolean,
            default: false
        },

        date: {
            type: String,
            default: ''
        },

        maxDate: {
            type: String,
            default: ''
        },

        scrollTarget:{
            type: String,
            default: ''
        }
    },
    data: ()=>{
        return {
            isOpen: false,

            activeDate: '',
            pickerOptions: {
                disabledDate: ''
            },
            activePickerKey: '',
            checkUserPop: false,
            checkConPop: false,
            curCompany: {
                id: 'ALL',
                name: '集团'
            },
            companyList: [],
            companyLoading: true
        }
    },
    mounted(){
        this.activeDate = this.date;
        this.activePickerKey = this.listActive;

        this.pickerOptions.disabledDate = time => {
            let minDate = '2021-01-01';
            let maxDate = this.maxDate ? new Date(this.maxDate).getTime() : Date.now();
            if ( time.getTime() < new Date(minDate).getTime() || time.getTime() > maxDate) {
                // 日历禁选 小于2021-01-01 及 大于当前日
                return true;
            }
        }

        this.$nextTick(()=>{
            // 页面滚动，自动关闭弹出的按钮
            var dom = this.scrollTarget ? document.getElementById(this.scrollTarget) : window;
            dom.onscroll = ()=>{
                if(this.isOpen){
                    this.isOpen = false;
                }
            }
        })
    },
    watch:{
        listActive: function(value){
            this.activePickerKey = value;
        }
    },
    computed:{
        curUserName: function(){
            let userObj = this.list.find(item=>{
                return item.userId == this.activePickerKey;
            });
            return userObj ? userObj.userName : '';
        }
    },
    created(){
        if(this.showCompanyPicker){
            this.fetchCompany();
        }
    },
    methods:{
        fetchCompany(){
            this.companyLoading = true;
            this.$http
                .post(this.$api.getIdcCompanyList.url)
                .then(res => {
                    this.companyList = res.data || [];
                    this.companyLoading = false;
                })
                .catch(err => {});
        },
        companyChange(con){
            if(con.id === this.curCompany.id) return;
            this.curCompany = con;
            this.$emit('companyChange',con);
            this.checkConPop = false;
        },
        userChange(user){
            if(user.userId === this.activePickerKey) return;
            this.activePickerKey = user.userId;
            this.$emit('userChange',user);
            this.checkUserPop = false;
        },
        dateChange(){
            this.$emit('dateChange',this.activeDate)
        },
        backTop(){
            var dom = this.scrollTarget ? document.getElementById(this.scrollTarget) : window;
            dom && dom.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
        refreshWeb(){
            location.reload();
        },

        close(){
            this.isOpen = false;
        }
    }
};
</script>
<style lang="scss">
.side-bar{
    position: fixed;
    bottom: 0;
	right: 0px;
    z-index: 2001;
    .bar{
        width: 70px;
        height: 70px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.16);
        background-color: #fff;
        position: relative;
        cursor: pointer;
    }
    .icon-box{
        font-size: 20px;
        margin-bottom: 4px;
    }
    .date-picker{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        opacity: 0;
        .el-date-editor,
        .el-input__inner{
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            width: 100%;
        }
        .el-input__inner{
            height: 100%;
            padding-left: 0;
        }
    }
}
.user-picker{
    padding: 10px;
    .picker-item{
        width: 80px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        margin-right: 14px;
        margin-bottom: 14px;
        cursor: pointer;
        &.active,
        &:hover{
            color: #FFFFFF;
            background-color: #213991;
            border-color: #213991;
        }
    }
}
.list-wrap{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.side-bar .plug-menu{
	width: 70px;
	height: 70px;
	border-radius: 100%;
	position: absolute;
	bottom: 16px;
	right: 16px;
	z-index: 999;
	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.16);
	background-color: #B70000;
	background-image: linear-gradient(to top, #FF0000, #B70000);
    transition: transform 200ms;
    &.colse{
        transform: rotateZ(0deg);
    }
    &.open{
        transform: rotateZ(135deg);
    }
}
.side-bar .plug-menu span {
    font-size: 30px;
    color: #213991;
}
.side-bar .plug-btn {
	position: absolute;
	bottom: 16px;
	right: 16px;
	z-index: 998;
	transition: transform 200ms;
}

.side-bar .plug-btn1.open {
	transform: translate(0, -185px) rotate(720deg);
}
.side-bar .plug-btn1.close {
	transform: translate(0, 0) rotate(0deg);
}
.side-bar .plug-btn2.open {
	transform: translate(-79px, -147px) rotate(720deg);
}
.side-bar .plug-btn2.close {
	transform: translate(0, 0) rotate(0deg);
}
.side-bar .plug-btn3.open {
	transform: translate(-131px, -78px) rotate(720deg);
}
.side-bar .plug-btn3.close {
	transform: translate(0, 0) rotate(0deg);
}
.side-bar .plug-btn4.open {
	transform: translate(-160px, 0) rotate(720deg);
}
.side-bar .plug-btn4.close {
	transform: translate(0, 0) rotate(0deg);
}
.side-bar .themeStyle {
	background: #fff;
}
</style>
